// extracted by mini-css-extract-plugin
export default {"formSpace":"styles_formSpace__OsS2a"};